const BackArrow = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18.3014" cy="18.3014" r="18.3014" fill="#F4F4F4" />
      <path
        d="M11.6608 17.797C11.5178 17.94 11.4375 18.134 11.4375 18.3362C11.4375 18.5384 11.5178 18.7323 11.6608 18.8753L15.9746 23.1891C16.0449 23.2619 16.129 23.32 16.2221 23.36C16.3151 23.3999 16.4152 23.421 16.5164 23.4218C16.6177 23.4227 16.7181 23.4034 16.8118 23.3651C16.9055 23.3267 16.9907 23.2701 17.0623 23.1985C17.1339 23.1269 17.1905 23.0418 17.2288 22.9481C17.2672 22.8544 17.2865 22.7539 17.2856 22.6527C17.2847 22.5514 17.2637 22.4514 17.2237 22.3583C17.1837 22.2653 17.1256 22.1812 17.0528 22.1108L14.0407 19.0987L24.1393 19.0987C24.3415 19.0987 24.5355 19.0184 24.6785 18.8754C24.8215 18.7324 24.9018 18.5384 24.9018 18.3362C24.9018 18.1339 24.8215 17.9399 24.6785 17.7969C24.5355 17.6539 24.3415 17.5736 24.1393 17.5736L14.0407 17.5736L17.0528 14.5615C17.1917 14.4177 17.2686 14.225 17.2668 14.0251C17.2651 13.8252 17.1849 13.6339 17.0435 13.4925C16.9021 13.3511 16.7109 13.2709 16.5109 13.2692C16.311 13.2675 16.1184 13.3443 15.9746 13.4832L11.6608 17.797Z"
        fill="#646464"
      />
    </svg>
  );
};
export default BackArrow;
